import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { services, companyInfo } from '../mockData';

const ServicesPage = () => {
  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="relative min-h-[500px] flex items-center overflow-hidden bg-navy-primary">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.pexels.com/photos/269077/pexels-photo-269077.jpeg" 
            alt="Commercial Property" 
            className="w-full h-full object-cover opacity-30"
          />
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-32">
          <div className="max-w-4xl">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-8 leading-tight">
              Commercial Property Services
            </h1>
            
            <p className="text-xl sm:text-2xl text-white mb-12 leading-relaxed max-w-3xl">
              Professional landscape and snow management designed for commercial properties across Toronto and the GTA.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6">
              <Link to="/contact">
                <Button 
                  size="lg" 
                  className="bg-white text-navy-primary hover:bg-ice-blue transition-all duration-300 shadow-lg hover:shadow-xl text-lg px-8 py-6"
                >
                  Request a Quote
                  <ArrowRight className="ml-2" size={20} />
                </Button>
              </Link>
              
              <a href={`tel:${companyInfo.phone.replace(/[^0-9]/g, '')}`}>
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="border-2 border-white text-white hover:bg-white hover:text-navy-primary transition-all duration-300 text-lg px-8 py-6"
                >
                  <Phone className="mr-2" size={20} />
                  {companyInfo.phone}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl sm:text-5xl font-bold text-navy-primary mb-16">
              Our Services
            </h2>

            <div className="space-y-16">
              {services.map((service, index) => (
                <Card key={service.id} className="overflow-hidden border-0 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className={`grid grid-cols-1 lg:grid-cols-2 gap-0 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                    {/* Image */}
                    <div className={`h-80 lg:h-auto ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                      <img 
                        src={service.image} 
                        alt={service.title} 
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Content */}
                    <div className={`p-8 lg:p-12 flex flex-col justify-center ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                      <h3 className="text-3xl font-bold text-navy-primary mb-6">
                        {service.title}
                      </h3>
                      <p className="text-xl text-gray-700 leading-relaxed mb-8">
                        {service.description}
                      </p>
                      <Link to="/contact">
                        <Button className="bg-navy-primary hover:bg-navy-secondary text-white group">
                          Get a Quote
                          <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
                        </Button>
                      </Link>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-navy-primary text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl sm:text-5xl font-bold mb-8">
            Ready to discuss your property needs?
          </h2>
          <p className="text-xl text-ice-blue/90 mb-12 max-w-2xl mx-auto">
            Contact us for a customized quote for your commercial property.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link to="/contact">
              <Button 
                size="lg" 
                className="bg-white text-navy-primary hover:bg-ice-blue transition-all duration-300 shadow-lg hover:shadow-xl text-lg px-8 py-6"
              >
                Request a Quote
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
            
            <a href={`tel:${companyInfo.phone.replace(/[^0-9]/g, '')}`}>
              <Button 
                size="lg" 
                variant="outline" 
                className="border-2 border-white text-white hover:bg-white hover:text-navy-primary transition-all duration-300 text-lg px-8 py-6"
              >
                <Phone className="mr-2" size={20} />
                {companyInfo.phone}
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
